import { Link } from "react-router-dom";
import { starProfile, topics } from "@/mocks/site";

export default function StarSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-stretch">
        <div className="lg:col-span-5">
          <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20scene%20of%20a%20graceful%20woman%20in%20refined%20rose%20dress%20sitting%20by%20a%20warm%20window%2C%20soft%20golden%20natural%20light%2C%20minimal%20beige%20interior%20with%20subtle%20gold%20accents%2C%20magazine%20cover%20photography%2C%20high%20detail&width=1000&height=750&seq=ym-profile-01&orientation=landscape"
              alt="杨幂人物简介配图"
              title="杨幂 - 明星简介"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-foreground-950/80 to-transparent">
              <p className="font-heading text-2xl font-bold text-background-50">{starProfile.name}</p>
              <p className="text-xs tracking-widest text-background-200/90 font-label">{starProfile.enName}</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          <span className="inline-flex items-center gap-2 text-xs font-label font-semibold text-primary-600 mb-2">
            <span className="w-4 h-px bg-primary-500" />
            明星简介
          </span>
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">关于{starProfile.name}</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{starProfile.intro}</p>

          <div className="mt-6 grid grid-cols-2 gap-4">
            {starProfile.facts.map((f) => (
              <div key={f.label} className="bg-background-100 border border-background-200 rounded-lg p-4">
                <p className="text-xs text-foreground-500 font-label">{f.label}</p>
                <p className="mt-1 font-heading text-sm md:text-base font-semibold text-foreground-950">{f.value}</p>
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap gap-3">
            {topics.map((t) => (
              <Link
                key={t.id}
                to={t.link}
                className="group inline-flex items-center gap-2 px-4 h-10 rounded-md bg-secondary-100 text-secondary-900 text-sm font-label hover:bg-secondary-200 transition-colors whitespace-nowrap"
              >
                <i className={`${t.icon} text-base text-primary-600`} />
                {t.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}